import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Dependent from "../../components/DependentForm";
import SuccessDialog2 from "../../components/SuccessDialog2";
import ContractModel from "../../data/models/contract";
import PlansByClubModel from "../../data/models/PlansByClub";
import RelationshipModel from "../../data/models/relationship";
import {
  getContractAssociatedInfo,
  getContractInfo,
  getIdContract,
  setIdCategory,
} from "../../data/services/crew_service";
import {
  getCities,
  getLimitedRelationships,
  getRelationships,
  getUnidades,
  privateSendFormFunction,
  sendFormFunction,
} from "../../data/services/form_contract";
import { getPlansByClub } from "../../data/services/person_service";
import {
  ChoosePlanCard,
  ConfirmButton,
  CrewStyle,
  DependentsButton,
  FormContainer,
  FormField,
  FormInput,
  FormRow,
  LoadingOverlay,
  PlansDropdown,
  Spinner,
  WrapContent,
} from "../../styles/PFform";
import { endpoint } from "../../utils/constants";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { BackButton } from "../../styles/AddAdherense";
import { FaArrowLeft } from "react-icons/fa";
import { TYPEREGISTER } from "../../core/app-urls";
import LimitedRelationshipModel from "../../data/models/limitedRelationship";
import { removeMask } from "../../utils/remove_mask";

const BlurWrapper = styled.div<{ isBlurred: boolean }>`
  filter: ${(props) => (props.isBlurred ? "blur(5px)" : "none")};
  width: 100%;
  height: 100%;
`;

export default function PFform() {
  const [plans, setPlans] = useState<ContractModel["planos"]>([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [contractData, setContractData] = useState<any>(null);
  const [municipios, setMunicipios] = useState<any>([]);
  const [relationships, setRelationships] = useState<
    LimitedRelationshipModel[]
  >([]);
  const [estados, setEstados] = useState<Set<string>>(new Set());
  const [categorias, setCategorias] = useState<PlansByClubModel[]>([]);
  const [selectedPlanName, setSelectedPlanName] = useState<string>("");
  const [unidades, setUnidades] = useState<any>([]);
  const [selectedUnity, setSelectedUnity] = useState<string>("");
  const [selectedName, setSelectedName] = useState<string>("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [dependents, setDependents] = useState<
    {
      nome: string;
      telefone: string;
      cpf: string;
      email: string;
      relationship: string;

      // campos esperados do DependentForm quando o usuário fizer upload
      documentoFrente?: File | null;
      documentoVerso?: File | null;
    }[]
  >([]);
  const [formData, setFormData] = useState({
    nome: "",
    cpf: "",
    telefone: "",
    email: "",
    cep: "",
    rua: "",
    bairro: "",
    numero: "",
    cidade: "",
    estado: "",
    clube: "",
  });
  const navigate = useNavigate();

  const [documentoFrente, setDocumentoFrente] = useState<File | null>(null);
  const [documentoVerso, setDocumentoVerso] = useState<File | null>(null);

  const location = useLocation();
  const privateForm = location.state?.privateForm ?? false;

  const handleFileChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    tipo: "frente" | "verso"
  ) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      if (tipo === "frente") {
        setDocumentoFrente(file);
      } else {
        setDocumentoVerso(file);
      }
    }
  };

  const handleButtonClick = (tipo: "frente" | "verso") => {
    if (tipo === "frente") {
      document.getElementById("uploadFrente")?.click();
    } else {
      document.getElementById("uploadVerso")?.click();
    }
  };

  useEffect(() => {
    async function loadInitialData() {
      try {
        const idContract = getIdContract();

        const [contractInfo, municipiosInfo, categoriasInfo] =
          await Promise.all([
            getContractInfo(idContract),
            getCities(),
            getPlansByClub(localStorage.getItem("selectedClubId")!),
          ]);

        if (contractInfo?.contract) {
          setContractData(contractInfo.contract);
          setPlans(contractInfo.contract.planos || []);
        }

        if (municipiosInfo) {
          setMunicipios(municipiosInfo.cities);
          setEstados(new Set(municipiosInfo.states));
        }

        if (categoriasInfo?.data) {
          setCategorias(categoriasInfo.data);
        }
      } catch (error) {
        console.error("Erro ao carregar dados iniciais:", error);
      }
    }

    const fetchUnidades = async () => {
      try {
        const { unidades } = await getUnidades();
        setUnidades(unidades);
      } catch (error) {
        console.error("Erro ao buscar unidades:", error);
      }
    };

    loadInitialData();
    fetchUnidades();
  }, []);

  useEffect(() => {
    if (municipios.length === 0) return;

    async function loadCpfData() {
      try {
        const cpf = localStorage.getItem("cpf_cnpj");
        if (!cpf) return;

        const { contract } = await getContractAssociatedInfo(cpf);
        if (!contract) {
          alert("Nenhum contrato associado encontrado para o CPF informado.");
          return;
        }

        const cidadeEncontrada = municipios.find(
          (m: any) => String(m.codigo) === String(contract.idCidade)
        );

        const cidadeCodigo = cidadeEncontrada?.codigo ?? "";
        const estadoSigla = cidadeEncontrada?.uf ?? "";

        setFormData((prev) => ({
          ...prev,
          cpf,
          nome: contract.nome || "",
          telefone: contract.telefoneEmp || "",
          email: contract.emailCob || "",
          cep: contract.cep || "",
          rua: contract.logradouro || "",
          bairro: contract.bairro || "",
          numero: contract.numero || "",
          estado: estadoSigla,
          cidade: cidadeCodigo,
          clube: contract.idClube!,
        }));
        setSelectedUnity(contract.idClube!);
        setSelectedName(contract.nome!);
      } catch (error) {
        console.error("Erro ao carregar dados do CPF:", error);
      }
    }

    loadCpfData();
  }, [municipios]);

  const uploadFile = async (file: File) => {
    const formData = new FormData();
    formData.append("files", file);

    try {
      const response = await axios.post(
        `${endpoint}/upload/documents`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      return response.data.data;
    } catch (error) {
      console.error("Erro ao enviar arquivo:", error);
      return [];
    }
  };

  const addDependent = () => {
    setDependents([
      ...dependents,
      { nome: "", telefone: "", cpf: "", email: "", relationship: "" },
    ]);
  };

  const removeDependent = (index: number) => {
    setDependents(dependents.filter((_, i) => i !== index));
  };

  // aceitamos "any" em value para permitir File | string etc (mínima mudança)
  const updateDependent = (index: number, field: string, value: any) => {
    setDependents((prev) =>
      prev.map((dependent, i) =>
        i === index ? { ...dependent, [field]: value } : dependent
      )
    );
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (name === "nome") {
      setSelectedName(value);
    }
  };

  const renameFile = (file: File, newName: string): File => {
    return new File([file], newName, { type: file.type });
  };

  const handleConfirmClick = async () => {
    if (
      !formData.nome ||
      !formData.cpf ||
      !formData.email ||
      !formData.cidade ||
      !formData.estado
    ) {
      alert("Preencha todos os campos obrigatórios!");
      return;
    }

    if (selectedPlanName == "") {
      alert("Escolha um plano para continuar");
      return;
    }

    if (!documentoFrente || !documentoVerso) {
      alert("Por favor, envie os dois documentos (frente e verso).");
      return;
    }

    for (let i = 0; i < dependents.length; i++) {
      const dep = dependents[i];

      if (!dep.nome || !dep.cpf || !dep.relationship) {
        alert(`Preencha todos os campos do dependente ${i + 1}.`);
        return;
      }

      if (!dep.documentoFrente || !dep.documentoVerso) {
        alert(`Envie os documentos (frente e verso) do dependente ${i + 1}.`);
        return;
      }
    }

    try {
      setIsSubmitting(true);
      const cpf = localStorage.getItem("cpf_cnpj") || formData.cpf;

      const unityPadded = selectedUnity.padStart(3, "0");

      const frenteNome = `${unityPadded}-${cpf}-${selectedName}-FrenteRg.${documentoFrente.name
        .split(".")
        .pop()}`;
      const versoNome = `${unityPadded}-${cpf}-${selectedName}-VersoRg.${documentoVerso.name
        .split(".")
        .pop()}`;

      const frenteRenomeado = renameFile(documentoFrente, frenteNome);
      const versoRenomeado = renameFile(documentoVerso, versoNome);

      const frenteUpload = await uploadFile(frenteRenomeado);
      const versoUpload = await uploadFile(versoRenomeado);

      for (let i = 0; i < dependents.length; i++) {
        const dep = dependents[i];

        if (dep.documentoFrente) {
          const cpfDep = dep.cpf || "";
          const nomeDep = (dep.nome || "").replace(/\s+/g, "_") || "dependente";
          const extFrente = dep.documentoFrente.name.split(".").pop();
          const nomeFrenteDep = `${unityPadded}-${cpfDep}-${nomeDep}-FrenteRg.${extFrente}`;
          const frenteRenomeadoDep = renameFile(
            dep.documentoFrente,
            nomeFrenteDep
          );
          await uploadFile(frenteRenomeadoDep);
        }

        if (dep.documentoVerso) {
          const cpfDep = dep.cpf || "";
          const nomeDep = (dep.nome || "").replace(/\s+/g, "_") || "dependente";
          const extVerso = dep.documentoVerso.name.split(".").pop();
          const nomeVersoDep = `${unityPadded}-${cpfDep}-${nomeDep}-VersoRg.${extVerso}`;
          const versoRenomeadoDep = renameFile(
            dep.documentoVerso,
            nomeVersoDep
          );
          await uploadFile(versoRenomeadoDep);
        }
      }

      // if (!frenteUpload || !versoUpload) {
      //   alert("Erro ao fazer upload dos documentos.");
      //   return;
      // }

      const cidadeObj = municipios.find(
        (m: any) => String(m.codigo) === String(formData.cidade)
      );

      const estadoId = cidadeObj?.codigoUf ?? null;

      const response = await sendFormFunction(
        formData.cpf,
        formData.nome,
        formData.telefone,
        formData.cep,
        formData.rua,
        formData.email,
        formData.bairro,
        formData.numero,
        "",
        parseInt(formData.cidade),
        estadoId,
        parseInt(formData.clube),
        new Date().toISOString(),
        parseInt(localStorage.getItem("enterpriseID")!),
        parseInt(localStorage.getItem("categoryID")!),
        3,
        parseInt(localStorage.getItem("contractNumber")!),
        parseInt(localStorage.getItem("contracdID")!),
        dependents.map((dep) => ({
          Nome_dependente: dep.nome,
          Grau_parentesco: parseInt(dep.relationship),
          Telefone_dependente: removeMask(dep.telefone),
          CPF_dependente: dep.cpf,
          Email_dependente: dep.email,
        }))
      );

      if (response.holderId) {
        setIsDialogOpen(true);
      } else {
        alert(`Erro ao enviar o formulário: ${response.errorMessage}`);
      }
    } catch (error) {
      console.error("Erro ao cadastrar:", error);
      alert("Erro ao enviar o formulário. Tente novamente.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handlePrivateConfirmClick = async () => {
    if (
      !formData.nome ||
      !formData.cpf ||
      !formData.email ||
      !formData.cidade ||
      !formData.estado
    ) {
      alert("Preencha todos os campos obrigatórios!");
      return;
    }

    if (!documentoFrente || !documentoVerso) {
      alert("Por favor, envie os dois documentos (frente e verso).");
      return;
    }

    try {
      const cpf = localStorage.getItem("cpf_cnpj") || formData.cpf;

      const frenteNome = `${cpf}-FrenteRg.${documentoFrente.name
        .split(".")
        .pop()}`;
      const versoNome = `${cpf}-VersoRg.${documentoVerso.name
        .split(".")
        .pop()}`;

      const frenteRenomeado = renameFile(documentoFrente, frenteNome);
      const versoRenomeado = renameFile(documentoVerso, versoNome);

      await uploadFile(frenteRenomeado);
      await uploadFile(versoRenomeado);

      for (let i = 0; i < dependents.length; i++) {
        const dep = dependents[i];

        if (dep.documentoFrente) {
          const cpfDep = dep.cpf || "";
          const nomeDep = (dep.nome || "").replace(/\s+/g, "_") || "dependente";
          const extFrente = dep.documentoFrente.name.split(".").pop();
          const nomeFrenteDep = `${cpfDep}-FrenteRg.${extFrente}`;
          const frenteRenomeadoDep = renameFile(
            dep.documentoFrente,
            nomeFrenteDep
          );
          await uploadFile(frenteRenomeadoDep);
        }

        if (dep.documentoVerso) {
          const cpfDep = dep.cpf || "";
          const nomeDep = (dep.nome || "").replace(/\s+/g, "_") || "dependente";
          const extVerso = dep.documentoVerso.name.split(".").pop();
          const nomeVersoDep = `${cpfDep}-VersoRg.${extVerso}`;
          const versoRenomeadoDep = renameFile(
            dep.documentoVerso,
            nomeVersoDep
          );
          await uploadFile(versoRenomeadoDep);
        }
      }

      const response = await privateSendFormFunction(
        "00000000000000", // ajuste conforme necessidade
        new Date(), // dataInclusao
        null, // dataFinalizacao
        formData.nome,
        formData.cpf,
        new Date(), // dataNasc
        1,
        formData.email,
        formData.cep,
        formData.rua,
        formData.numero,
        "a",
        parseInt(formData.cidade),
        123,
        formData.telefone,
        "2",
        1,
        null,
        null,
        formData.bairro || "",
        parseInt(localStorage.getItem("id")!),
        dependents.map((dep) => ({
          Nome_dependente: dep.nome,
          Grau_parentesco: parseInt(dep.relationship),
          Telefone_dependente: dep.telefone,
          CPF_dependente: dep.cpf,
          Email_dependente: dep.email,
        }))
      );

      if (response.holderId) {
        setIsDialogOpen(true);
      } else {
        alert(`Erro ao enviar o formulário: ${response.errorMessage}`);
      }
    } catch (error) {
      console.error("Erro ao cadastrar:", error);
      alert("Erro ao enviar o formulário. Tente novamente.");
    }
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handlePlansDropdown = async (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedIdCategory = event.target.value;
    setIdCategory(selectedIdCategory);

    const selectedPlan = plans.find(
      (plano) => plano.idCategoria === selectedIdCategory
    );

    if (selectedPlan) {
      setSelectedPlanName(selectedPlan.categoria || "");
    }

    try {
      const { relationships } = await getLimitedRelationships(
        selectedIdCategory
      );

      setRelationships(relationships);
    } catch (error) {
      console.error("Erro ao buscar relacionamentos:", error);
      setRelationships([]);
    }

    console.log(selectedIdCategory);
  };

  return (
    <CrewStyle>
      {isSubmitting && (
        <LoadingOverlay>
          <Spinner />
        </LoadingOverlay>
      )}
      <BackButton onClick={() => navigate(TYPEREGISTER)}>
        <FaArrowLeft />
        Voltar
      </BackButton>
      <WrapContent>
        <h1>PORTAL DO CLIENTE</h1>
        <h3>Cadastro</h3>
        <BlurWrapper isBlurred={isDialogOpen}>
          <ChoosePlanCard>
            <PlansDropdown name="" onChange={handlePlansDropdown}>
              <option value="" disabled selected>
                CLIQUE AQUI E ESCOLHA O PLANO
              </option>
              {categorias.length === 0 ? (
                <>
                  {plans.map((plano) => (
                    <option
                      key={plano.idContratoCategoria}
                      value={plano.idCategoria!}
                    >
                      {plano.categoria} - R$ {plano.valor}
                    </option>
                  ))}
                </>
              ) : (
                <>
                  {categorias.map((cat) => (
                    <option key={cat.idCategoria} value={cat.idCategoria}>
                      {cat.categoria} - R$ {cat.valor}
                    </option>
                  ))}
                </>
              )}
            </PlansDropdown>
            <FormContainer>
              <p>Complete as informações necessárias para seu cadastro.</p>
              <FormField>
                <FormInput
                  type="text"
                  name="nome"
                  placeholder="Nome Completo"
                  value={formData.nome}
                  onChange={handleInputChange}
                />
              </FormField>
              <FormField>
                <FormInput
                  type="text"
                  name="cpf"
                  placeholder="CPF"
                  value={formData.cpf}
                  onChange={handleInputChange}
                  readOnly
                />
              </FormField>
              <FormField>
                <FormInput
                  type="tel"
                  name="telefone"
                  placeholder="Telefone"
                  value={formData.telefone}
                  onChange={handleInputChange}
                />
              </FormField>
              <FormField>
                <FormInput
                  type="email"
                  name="email"
                  placeholder="E-mail"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </FormField>
              <FormField>
                <FormInput
                  type="text"
                  name="cep"
                  placeholder="CEP"
                  value={formData.cep}
                  onChange={handleInputChange}
                />
              </FormField>
              <FormField>
                <FormInput
                  type="text"
                  name="rua"
                  placeholder="Rua"
                  value={formData.rua}
                  onChange={handleInputChange}
                />
              </FormField>
              <FormRow>
                <FormField>
                  <FormInput
                    type="text"
                    name="bairro"
                    placeholder="Bairro"
                    value={formData.bairro}
                    onChange={handleInputChange}
                  />
                </FormField>
                <FormField>
                  <FormInput
                    type="text"
                    name="numero"
                    placeholder="Nº"
                    value={formData.numero}
                    onChange={handleInputChange}
                  />
                </FormField>
              </FormRow>
              <FormRow>
                <FormField>
                  <select
                    name="estado"
                    value={formData.estado}
                    onChange={handleInputChange}
                  >
                    <option value="" disabled>
                      Escolha o estado
                    </option>
                    {Array.from(estados).map((uf) => (
                      <option key={uf} value={uf}>
                        {uf}
                      </option>
                    ))}
                  </select>
                </FormField>
                <FormField>
                  <select
                    name="cidade"
                    value={formData.cidade}
                    onChange={handleInputChange}
                    disabled={!formData.estado}
                  >
                    <option value="" disabled>
                      Escolha a cidade
                    </option>
                    {municipios
                      .filter((m: any) => m.uf === formData.estado)
                      .map((m: any) => (
                        <option key={m.codigo} value={m.codigo}>
                          {m.nomeMunicipio}
                        </option>
                      ))}
                  </select>
                </FormField>
                <FormField>
                  <select
                    name="unidade"
                    value={formData.clube}
                    onChange={(e) => {
                      setFormData({ ...formData, clube: e.target.value });

                      setSelectedUnity(e.target.value);
                    }}
                  >
                    <option value="" disabled>
                      Escolha a unidade
                    </option>
                    {unidades.map((u: any) => (
                      <option key={u.id_clube} value={u.id_clube}>
                        {u.razao_social}
                      </option>
                    ))}
                  </select>
                </FormField>
              </FormRow>
              <FormField>
                <button
                  type="button"
                  onClick={() => handleButtonClick("frente")}
                >
                  Faça upload de um documento original com foto (RG, CNH)
                </button>
                <input
                  id="uploadFrente"
                  type="file"
                  accept="image/*,application/pdf"
                  style={{ display: "none" }}
                  onChange={(e) => handleFileChange(e, "frente")}
                />
                {documentoFrente && (
                  <p>Arquivo selecionado: {documentoFrente.name}</p>
                )}
              </FormField>
              <FormField>
                <button
                  type="button"
                  onClick={() => handleButtonClick("verso")}
                >
                  Faça upload de um documento original com foto (RG, CNH) -
                  Verso
                </button>
                <input
                  id="uploadVerso"
                  type="file"
                  accept="image/*,application/pdf"
                  style={{ display: "none" }}
                  onChange={(e) => handleFileChange(e, "verso")}
                />
                {documentoVerso && (
                  <p>Arquivo selecionado: {documentoVerso.name}</p>
                )}
              </FormField>
              {(() => {
                const name = selectedPlanName.trim().toLowerCase();

                const endsWithIndividual = name.endsWith("individual");
                const hasExtraAfterIndividual = /individual\s+\S+/i.test(name);

                if (endsWithIndividual && !hasExtraAfterIndividual) {
                  return null;
                }

                if (
                  (name.includes("individual + 1 agregado") ||
                    name.includes("individual+1agregado") ||
                    name.includes("individual+1 agregado")) &&
                  dependents.length >= 1
                ) {
                  return null;
                }
                return (
                  <DependentsButton onClick={addDependent}>
                    + DEPENDENTE
                  </DependentsButton>
                );
              })()}
              {dependents.map((dependent, index) => (
                <Dependent
                  key={index}
                  index={index}
                  dependent={dependent}
                  onRemove={removeDependent}
                  onChange={updateDependent}
                  relationships={relationships}
                />
              ))}
            </FormContainer>
            {privateForm === true ? (
              <ConfirmButton
                isExpanded={true}
                onClick={handlePrivateConfirmClick}
              >
                Concluir
              </ConfirmButton>
            ) : (
              <ConfirmButton
                isExpanded={true}
                onClick={handleConfirmClick}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Carregando..." : "Concluir"}
              </ConfirmButton>
            )}
          </ChoosePlanCard>
        </BlurWrapper>
        <SuccessDialog2
          message="Pré-adesão realizada com sucesso!"
          isOpen={isDialogOpen}
          onClose={handleCloseDialog}
        />
      </WrapContent>
    </CrewStyle>
  );
}
